import React from "react";
import MaterialSwitch from "./MaterialSwitch";
import "./LabeledSwitch.css";

type LabeledSwitchProps = {
  id: string;
  label: string;
  name: string; // Added name prop
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean; // Added disabled prop
};

const LabeledSwitch: React.FC<LabeledSwitchProps> = ({ id, label, name, checked, onChange, disabled }) => {
  return (
    <div className="labeled-switch">
      <label htmlFor={id} className="labeled-switch-label">
        {label}
      </label>
      <MaterialSwitch id={id} name={name} checked={checked} onChange={onChange} disabled={disabled} />
    </div>
  );
};

export default LabeledSwitch;
